import { isArray, isNumber, isObject, isPlainObject, isString } from '@dimjs/lang';
import { isUndefinedOrNull, TPlainObject } from '@flatbiz/utils';

export const omit = (target: Record<string, any>, keys: string[]) => {
  const newTarget = {} as Record<string, any>;
  Object.keys(target).map((key) => {
    if (!keys.includes(key)) {
      newTarget[key] = target[key];
    }
  });
  return newTarget;
};

export const getFormModalPickerValue = <T extends string | number>(value: any) => {
  if (isUndefinedOrNull(value)) return undefined;
  if (isString(value) || isNumber(value)) {
    return value as T;
  }
  if (isArray(value)) {
    return value.map((temp) => {
      if (isPlainObject(temp)) {
        return temp.value as T;
      }
      return temp as T;
    });
  }
  const pickerValue = value.value;
  if (isUndefinedOrNull(pickerValue)) return undefined;
  if (isArray(pickerValue)) {
    return pickerValue.map((temp) => {
      if (isPlainObject(temp)) {
        return temp.value as T;
      }
      return temp as T;
    });
  }
  if (isPlainObject(pickerValue)) {
    return (pickerValue.value || pickerValue) as T;
  }
  return pickerValue as T;
};

export const getFormModalPickerLabel = (value: any) => {
  if (isUndefinedOrNull(value)) return undefined;
  if (isString(value) || isNumber(value)) {
    return `${value}`;
  }
  if (isArray(value)) {
    return value
      .filter(Boolean)
      .map((temp) => {
        if (isPlainObject(temp)) {
          return `${temp.label || temp.value}`;
        }
        return `${temp}`;
      })
      .join('');
  }
  const pickerValue = value.value;
  if (isUndefinedOrNull(pickerValue)) return undefined;
  if (isArray(pickerValue)) {
    return pickerValue
      .filter(Boolean)
      .map((temp) => {
        if (isPlainObject(temp)) {
          return `${temp.label || temp.value}`;
        }
        return `${temp}`;
      })
      .join('');
  }
  if (isPlainObject(pickerValue)) {
    return `${pickerValue.value}`;
  }
  return `${pickerValue}`;
};

export const getFormModalValue = (value: any) => {
  if (isUndefinedOrNull(value)) return undefined;
  if (isPlainObject(value)) {
    return value.value as unknown;
  }
  return value as unknown;
};

export const toLabelValue = (value: TPlainObject | string | number) => {
  if (isUndefinedOrNull(value)) return undefined;
  if (isObject(value)) {
    return { label: (value['label'] || value['value']) as string, value: value['value'] as string | number };
  }
  return { label: `${value}`, value: value as string | number };
};
